import React from "react";

import { Box, useMediaQuery } from "@mui/material";

import CustomPieChart from "../../../../components/customPieChart/CustomPieChart";

const BoxDistributionViewedPages = ({ data }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const parsedDataset = Object.entries(data).map(([page, value]) => ({
    label: page,
    value: Number(value),
  }));

  return (
    <Box
      sx={{
        justifyContent: "center", // Centra orizzontalmente
        alignSelf: "center", // Centra verticalmente
      }}
    >
      <CustomPieChart
        dataset={parsedDataset}
        width={isMobile ? 250 : 400}
        height={isMobile ? 400 : 400}
      />
    </Box>
  );
};

export default BoxDistributionViewedPages;
